import { render } from "./VUEComponenteGraficoSpostamentiSovrapposti.vue?vue&type=template&id=0961e4e0"
import script from "./VUEComponenteGraficoSpostamentiSovrapposti.vue?vue&type=script&lang=js"
export * from "./VUEComponenteGraficoSpostamentiSovrapposti.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__